export default class SubmitOnceForm {
  constructor (element) {
    element.addEventListener('submit', event => {
      element.querySelectorAll('button[type="submit"]').forEach(submitButton => {
        submitButton.disabled = true
      })
    })
  }
}
